module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/backward-fe7a144ac26b34c2aac4841b3ff56398.svg";